import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SubscriptionError {
  error: string | null
}

interface SubscriptionErrorState {
  value: SubscriptionError | null
}

const initialState: SubscriptionErrorState = { value: null }

const subscriptionErrorSlice = createSlice({
  name: 'subscriptionError',
  initialState,
  reducers: {
    saveSubscriptionError(state, action: PayloadAction<string>) {
      state.value = {
        error: action.payload,
      }
    },
    resetSubscriptionError(state) {
      if (state.value) {
        state.value = {
          error: null,
        }
      }
    },
  },
})

export const { saveSubscriptionError, resetSubscriptionError } = subscriptionErrorSlice.actions
export default subscriptionErrorSlice.reducer
